import { FVProfile, References, Classification } from '../types';

export function classifyAthlete(fvProfile: FVProfile, refs: References): Classification {
  const { F0_rel, V0 } = fvProfile;
  const { F0_ref_Nkg, V0_ref_ms } = refs;
  
  // Calculate z-scores
  const zF = (F0_rel - F0_ref_Nkg) / F0_ref_Nkg;
  const zV = (V0 - V0_ref_ms) / V0_ref_ms;
  
  // Calculate delta
  const delta = zV - zF;
  
  // Classify based on delta
  let label: Classification['label'];
  if (delta > 0.10) {
    label = 'Speed-oriented';
  } else if (delta < -0.10) {
    label = 'Force-oriented';
  } else {
    label = 'Balanced';
  }
  
  return {
    label,
    delta,
    zF,
    zV
  };
}

export function getTrainingRecommendations(classification: Classification): string[] {
  switch (classification.label) {
    case 'Speed-oriented':
      return [
        'Focus on heavy resisted sprints (40-55% v-loss)',
        'Strength training with emphasis on force production',
        'Sled pulls and weighted sprints',
        'Maintain speed work but prioritize force development'
      ];
    case 'Force-oriented':
      return [
        'Emphasize light resistance training (0-25% v-loss)',
        'Overspeed training and assisted sprints',
        'Technical sprint work at high velocities',
        'Maintain strength but prioritize speed development'
      ];
    case 'Balanced':
      return [
        'Maintain current training balance',
        'Focus on power development (25-40% v-loss)',
        'Periodize between force and speed phases',
        'Continue well-rounded approach'
      ];
    default:
      return [];
  }
}